import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading font-bold text-primary-500">97</span>
              <span className="text-xl font-heading font-semibold text-foreground-50">影视</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              97影视网，汇聚海量电影资源，涵盖动作片、喜剧片等各类最新高清电影，全集免费在线观看，播放流畅不缓冲，给您极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">电影分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  用户反馈
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/30 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 97影视 - 97影视网电影大全。本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}